<script lang="ts">
  import SvgLetter from "./SvgLetter.svelte";
</script>

<h1>Mercy</h1>
<div class="letters">
  <SvgLetter width="24.4%" d="M468 293l396 -301v758h-154v-449l-242 175l-242 -175v449h-155v-758z" viewBox="-10 -50 946 1000" />
  <SvgLetter width="15.1%" d="M533 750h-462v-745h396v140h-241v139h280v139h-280v187h307v140z" viewBox="-10 -50 583 1000" />
  <SvgLetter width="17.7%" d="M304 621h-78v129h-155v-745h259c175 0 309 131 309 293c0 134 -64 232 -168 280l161 172h-206zM226 481h64c123 0 190 -60 190 -171c0 -91 -54 -165 -160 -165h-94v336z" viewBox="-10 -50 685 1000" />
  <SvgLetter width="22.1%" d="M650 421h157c-22 191 -186 342 -384 342c-213 0 -383 -172 -383 -385s170 -386 382 -386c139 0 262 72 329 181l-121 86c-54 -80 -130 -119 -207 -119c-125 0 -224 106 -224 238c0 131 99 236 224 236c112 0 206 -81 227 -193z" viewBox="-10 -50 857 1000" />
  <SvgLetter width="20.7%" d="M389 371l218 -366h163l-306 505v240h-154v-226l-316 -519h178z" viewBox="-16 -50 796 1000" />
</div>

<style>
  h1 {
    display: none;
  }
  .letters {
    display: flex;
  }
</style>
